<template>
  <div class="goup">
    <div class="send-num-container" v-if="activityData.already_raffle_num">
      <div class="send-text">已送出小红花：</div>
      <div class="send-num">{{ activityData.already_raffle_num }}</div>
      <div class="send-record" @click="bindGetRecord"
        >查看送花记录<span class="iconfont icon-you"></span
      ></div>
    </div>
    <div v-else class="not-send-num-container"
      >你还没有送出小红花，送给教练鼓励-下!</div
    >
    <div class="btn-list" v-if="[1, 2].includes(activityInfo.activity_state)">
      <div class="btn-left" @click="bindSend">
        <img
          class="btn-left-image"
          src="https://btw-common-data.betterwestar.com/btw-admin/resource/8bcaad61854889f17dce785a456deafe_wh=738_303.png"
          alt=""
        />
        <div class="btn-left-container">
          <div class="num-content"
            ><span class="cha">x</span
            ><span class="num">{{ activityData.surplus_raffle_num }}</span></div
          >
        </div>
      </div>
      <div class="btn-right" @click="bindGetFlower">
        <img
          class="btn-right-image"
          src="https://btw-common-data.betterwestar.com/btw-admin/resource/00be168febb958641d279c6587c4182f_wh=423_303.png"
          alt=""
        />
        <div class="btn-right-container"></div>
      </div>
    </div>
    <div class="activity-end" v-if="activityInfo.activity_state == 3"
      >活动已结束</div
    >
    <PrizeList />
  </div>
</template>

<script>
import PrizeList from './prize-list.vue'
export default {
  components: { PrizeList },
  data() {
    return {}
  },
  computed: {
    activityInfo() {
      return this.$store.state.coachActivity2024.activityInfo
    },
    activityData() {
      return this.$store.state.coachActivity2024.activityData
    }
  },
  created() {},
  methods: {
    bindSend() {
      if (this.activityData.surplus_raffle_num) {
        this.$store.commit('coachActivity2024/setShowSendFlowerToast', true)
      } else {
        this.$toast('你还没有小红花哦~')
      }
    },
    bindMyPrize() {
      this.$store.commit('coachActivity2024/setMyPrizeToast', true)
    },
    bindGetFlower() {
      this.$store.commit('coachActivity2024/setTaskToast', true)
    },
    bindGetRecord() {
      this.$store.commit('coachActivity2024/setRecordToast', true)
    }
  }
}
</script>
<style lang="scss" scoped>
.goup {
  padding: 440px 0px 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  .send-num-container {
    font-weight: bold;
    font-size: 14px;
    color: #050b27;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    padding: 0px 16px 0px 23px;
    margin: 0 auto;
    width: 273px;
    height: 36px;
    background: rgba(255, 255, 255, 0.7);
    box-shadow: 0px 2px 4px 0px rgba(255, 172, 208, 0.37);
    border-radius: 18px;
    border: 1px solid #ffffff;
    backdrop-filter: blur(5px);
    box-sizing: border-box;
    .send-text {
      height: 20px;
    }
    .send-num-text {
      margin-right: 3px;
      font-weight: bold;
      font-size: 14px;
      color: #050b27;
      line-height: 20px;
    }
    .send-num {
      flex-shrink: 0;
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-family: DIN;
      font-weight: bold;
      font-size: 20px;
      color: #ff2270;
      line-height: 26px;
    }
    .send-record {
      display: flex;
      align-items: center;
      height: 20px;
      font-size: 12px;
      color: rgba(5, 11, 39, 0.7);
    }
  }
  .not-send-num-container {
    padding: 0px 16px;
    line-height: 36px;
    white-space: nowrap;
    height: 36px;
    background: rgba(255, 255, 255, 0.7);
    box-shadow: 0px 2px 4px 0px rgba(255, 172, 208, 0.37);
    border-radius: 18px;
    border: 1px solid #ffffff;
    backdrop-filter: blur(5px);
    font-weight: bold;
    font-size: 14px;
    color: #050b27;
  }
  .btn-list {
    width: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 0px 12px;
    margin-bottom: 18px;
    margin-top: 20px;
    .btn-left {
      position: relative;
      z-index: 1;
      width: 222px;
      height: 81px;
      .btn-left-image {
        position: absolute;
        z-index: -1;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 246px;
        height: 101px;
        object-fit: contain;
      }
      .btn-left-container {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        bottom: 0;
        .num-content {
          font-family: DIN;
          display: flex;
          align-items: center;
          position: absolute;
          left: 146px;
          bottom: 12px;
        }
        .cha {
          font-weight: bold;
          font-size: 17px;
          color: #ffe663;
          line-height: 24px;
        }

        .num {
          white-space: nowrap;
          font-weight: bold;
          font-size: 22px;
          color: #ffe663;
          line-height: 28px;
        }
      }
    }
    .btn-right {
      position: relative;
      z-index: 1;
      width: 117px;
      height: 81px;
      .btn-right-container {
        width: 100%;
        height: 100%;
      }
      .btn-right-image {
        width: 141px;
        height: 101px;
        object-fit: contain;
        position: absolute;
        z-index: -1;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }
  .activity-end {
    margin: 33px auto 20px auto;
    width: 335px;
    height: 53px;
    background: rgba(255, 255, 255, 0.5);
    border-radius: 41px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    font-size: 16px;
    color: rgba(5, 11, 39, 0.5);
  }
}
</style>
